import { $http } from "@/utils/http";
import { SET_AGENT_INFO, SET_AGENT_LOADING, SET_AGENT_INSTRUCTION } from "../mutation-types";

import { GET_AGENT_INFO, GET_AGENT_INSTRUCTION } from "../action-types";

const state = {
    agentItem: null,
    agentItemLoading: false,
    agentInstruction: null,
};
const getters = {
    agentItem: state => state.agentItem,
    agentItemLoading: state => state.agentItemLoading,
    agentInstruction: state => state.agentInstruction,
};
const actions = {
    [GET_AGENT_INFO]: async ({ commit }) => {
        commit(SET_AGENT_LOADING, true);
        try {
            const response = await $http.get("v1/agent_advantages");
            commit(SET_AGENT_INFO, response.data.data);
        } catch (e) {
            throw e;
        } finally {
            commit(SET_AGENT_LOADING, false);
        }
    },
    [GET_AGENT_INSTRUCTION]: async ({ commit }) => {
        commit(SET_AGENT_LOADING, true);
        try {
            const response = await $http.get("v1/settings/agent_instruction");
            commit(SET_AGENT_INSTRUCTION, response.data.agent_instruction);
            // console.log(response.data.agent_instruction);
        } catch (e) {
            throw e;
        } finally {
            commit(SET_AGENT_LOADING, false);
        }
    },
};
const mutations = {
    [SET_AGENT_LOADING](state, status) {
        state.agentItemLoading = status;
    },
    [SET_AGENT_INFO](state, data) {
        state.agentItem = data;
    },
    [SET_AGENT_INSTRUCTION](state, data) {
        state.agentInstruction = data;
    },
};
export default {
    state,
    getters,
    actions,
    mutations,
};
